// @flow
import type { Country } from '@tectonics/commons/country/country';
import type { ValidationFunction } from './types';

export type CustomerDocumentValidationConfig = {|
  documentValidationFunction?: ValidationFunction,
  specDocumentName?: string,
  documentInputFieldName?: string,
|};

export function getCustomerDocumentConfig(country: ?Country): CustomerDocumentValidationConfig {
  const document = country?.customerForm?.document;

  return {
    documentValidationFunction: document?.validationFunction,
    specDocumentName: document?.specDocumentName,
    documentInputFieldName: document?.inputFieldName,
  };
}
